import { useQuery } from "react-query";
import { namesUseQuery } from "../../utils/constants";
import { StoresService } from "../../services/StoresService";

export function useGetStoreById(id) {
  const { data, isLoading } = useQuery(
    [namesUseQuery?.GET_STORE_BY_ID, id],
    () => StoresService.getStoreById(id),
    {
      enabled: true,
      onError: (error) => {
        console.log(error);
      },
    }
  );

  return {
    data: data?.data,
    isLoading,
  };
}
